import { Button } from "@mui/material";
import { Modal } from "components/Modal";
import { useState } from "react";
import classes from "./style.module.scss";

export const CreateDemotionAgentModal = ({ open, onClose, selectedAgent, onConfirm }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirm = async () => {
    if (!selectedAgent?.id) return;

    setLoading(true);
    try {
      await onConfirm(selectedAgent.id);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      title="تبدیل ایجنت به کاربر"
      onClose={onClose}
      maxWidth="sm"
      footerEnd={
        <>
          <Button
            variant="contained"
            size="xsmall"
            loading={loading}
            color="success"
            onClick={handleConfirm}
          >
            بله
          </Button>
          <Button variant="contained" color="error" size="xsmall" onClick={onClose}>
            خیر
          </Button>
        </>
      }
    >
      <div className={classes.wrapper}>
        آیا از تبدیل ایجنت با ایمیل {selectedAgent?.email} به کاربر مطمئن هستید؟
      </div>
    </Modal>
  );
};
